@if (canWrite() && editing() === null) {
  <div class="d-flex justify-content-end mb-3">
    <button type="button" class="btn btn-sm btn-white" (click)="openNew()">
      <i class="fe fe-plus me-1"></i> Adicionar ação
    </button>
  </div>
}

@if (editing() !== null) {
  <div class="border rounded p-3 mb-3">
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label">Ação <span class="text-danger">*</span></label>
        <textarea class="form-control" rows="2" [(ngModel)]="description"
                  placeholder="O que vai ser feito para resolver"></textarea>
      </div>
      <div class="col-md-4">
        <label class="form-label">Responsável</label>
        <select class="form-select" [(ngModel)]="responsibleId">
          <option [ngValue]="null">—</option>
          @for (member of teamMembers(); track member.id) {
            <option [ngValue]="member.id">{{ member.name }}</option>
          }
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label">Estado</label>
        <select class="form-select" [(ngModel)]="status" data-no-filter>
          @for (option of statusOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>
    </div>
    @if (error()) { <div class="alert alert-danger small py-2 mt-3 mb-0">{{ error() }}</div> }
    <div class="d-flex justify-content-end gap-2 mt-3">
      <button type="button" class="btn btn-sm btn-white" (click)="cancel()">Cancelar</button>
      <button type="button" class="btn btn-sm btn-primary" (click)="save()" [disabled]="saving()">
        {{ saving() ? 'A guardar…' : (editing() === 0 ? 'Acrescentar' : 'Guardar') }}
      </button>
    </div>
  </div>
}

@if (error() && editing() === null) {
  <div class="alert alert-danger small py-2">{{ error() }}</div>
}

@if (actions().length === 0) {
  <p class="text-muted mb-0">
    Sem ações registadas. Cada ação tem o seu número, que o seguimento usa para dizer a qual se
    refere.
  </p>
} @else {
  <div class="table-responsive">
    <table class="table table-sm table-nowrap mb-0">
      <thead>
        <tr>
          <th>ID</th>
          <th class="text-wrap">Ação</th>
          <th>Responsável</th>
          <th>Estado</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (action of actions(); track action.id; let i = $index, first = $first, last = $last) {
          <tr>
            <td><span class="badge bg-secondary-soft">#{{ action.sequence }}</span></td>
            <td class="text-wrap">{{ action.description }}</td>
            <td>
              @if (action.responsibleName) { {{ action.responsibleName }} }
              @else { <span class="text-muted">—</span> }
            </td>
            <!-- Muda-se aqui ou na edição (revisão de 2026-10-19). Em seguimento chega sozinho,
                 quando o seguimento associa a ação; fechar a ocorrência fecha as que faltarem. -->
            <td>
              @if (canWrite()) {
                <select class="form-select form-select-sm w-auto" data-no-filter
                        [attr.aria-label]="'Estado da ação #' + action.sequence"
                        [ngModel]="action.status"
                        (ngModelChange)="changeStatus(action, $event)">
                  @for (option of statusOptions; track option.value) {
                    <option [ngValue]="option.value">{{ option.label }}</option>
                  }
                </select>
              } @else {
                <span class="badge" [class]="statusClass[action.status]">{{ statusLabels[action.status] }}</span>
              }
            </td>
            <td class="text-end">
              @if (canWrite()) {
                <!-- Mudar a ordem não renumera: o "#" é o nome da ação (revisão de 2026-10-13). -->
                @if (actions().length > 1) {
                  <button type="button" class="btn btn-sm btn-white me-1" (click)="move(i, -1)"
                          [disabled]="first" title="Subir">
                    <i class="fe fe-arrow-up"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-white me-2" (click)="move(i, 1)"
                          [disabled]="last" title="Descer">
                    <i class="fe fe-arrow-down"></i>
                  </button>
                }
                <button type="button" class="btn btn-sm btn-white me-1" (click)="openEdit(action)" title="Editar ação">
                  <i class="fe fe-edit-2"></i>
                </button>
                <button type="button" class="btn btn-sm btn-white" (click)="askRemove(action)" title="Remover ação">
                  <i class="fe fe-trash-2"></i>
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

@if (pendingRemoval(); as action) {
  <app-confirm-dialog
    title="Remover ação"
    [message]="'A ação #' + action.sequence + ' deixa de constar no tratamento. Os números das restantes não mudam.'"
    confirmLabel="Remover"
    [danger]="true"
    (confirm)="confirmRemove()"
    (cancel)="cancelRemove()"
  />
}
